import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, createSlots as _createSlots, createVNode as _createVNode, Fragment as _Fragment, Transition as _Transition, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["content"]
const _hoisted_2 = ["content"]
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { id: "header-fix" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", { id: "start" }, null, -1)
const _hoisted_6 = {
  key: 2,
  id: "likebar-fix"
}
const _hoisted_7 = {
  ref: "feedbackAudio",
  preload: "auto",
  volume: "0.2"
}
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_FeedbackModal = _resolveComponent("FeedbackModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.kabernetContext.isApp)
      ? (_openBlock(), _createBlock(_component_Head, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("title", null, _toDisplayString(_ctx.$t('App.window-title', { domain: _ctx.domain })), 1),
            _createElementVNode("meta", {
              name: "description",
              content: _ctx.metaDescription
            }, null, 8, _hoisted_1),
            _createElementVNode("meta", {
              property: "og:description",
              content: _ctx.metaDescription
            }, null, 8, _hoisted_2),
            (_ctx.generateCanonicalUrl)
              ? (_openBlock(), _createElementBlock("link", {
                  key: 0,
                  rel: "canonical",
                  href: _ctx.canonicalUrl
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: "container",
      class: _normalizeClass({ 'view-mobile': _ctx.isMobile })
    }, [
      (_ctx.showHeader)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_4,
            _createVNode(_component_TheHeader, null, _createSlots({ _: 2 }, [
              (_ctx.$slots.menu)
                ? {
                    name: "menu",
                    fn: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "menu")
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1024),
            _hoisted_5
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("main", null, [
        (_ctx.router)
          ? (_openBlock(), _createBlock(_component_router_view, {
              key: _ctx.$route.fullPath
            }))
          : _renderSlot(_ctx.$slots, "default", { key: 1 })
      ]),
      (_ctx.showFooter)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.$slots.footer)
              ? _renderSlot(_ctx.$slots, "footer", { key: 0 })
              : (_openBlock(), _createBlock(_component_TheFooter, { key: 1 }))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.showLikeBarFix)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
        : _createCommentVNode("", true),
      _createVNode(_Transition, { name: "fade-y" }, {
        default: _withCtx(() => [
          (_ctx.showFeedbackModal)
            ? (_openBlock(), _createBlock(_component_FeedbackModal, {
                key: 0,
                onClose: _ctx.closeFeedback
              }, null, 8, ["onClose"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("audio", _hoisted_7, [
        _createElementVNode("source", { src: _ctx.feedbackSoundUrl }, null, 8, _hoisted_8)
      ], 512)
    ], 2)
  ], 64))
}